import { render, staticRenderFns } from "./UnPinned.vue?vue&type=template&id=3c794b9c&scoped=true&"
import script from "./UnPinned.vue?vue&type=script&lang=js&"
export * from "./UnPinned.vue?vue&type=script&lang=js&"
import style0 from "./UnPinned.vue?vue&type=style&index=0&id=3c794b9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c794b9c",
  null
  
)

export default component.exports